import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../Store/UserSlice";
import { useEffect } from "react";
import { getUser } from "./Api";

export function useUser() {
    const dispatch = useDispatch();
    
    const user = useSelector(state => state.user.user);

    useEffect(() => {
        (async () => {
            // Getting Users from User Endpoint.
            try {
                const userResp = await getUser();
                if (!userResp.firstName) {
                    // login if we don't have a user
                    redirectToLogin();
                } else {
                    dispatch(userActions.setUser({ user: userResp }));
                }
            }
            catch (error) {
                console.log(error)
                /* Workaround to detect unauthorized 401 which means not logged in */
                if ((error.message ?? "").indexOf("401") !== false) {
                    redirectToLogin()
                }
                else if ((error.message ?? "").indexOf("403") !== false) {
                    redirectToLogout()
                }
            }
        })();

    }, [dispatch]);

    return user;
}

export function redirectToLogin() {
    /* Voting production server has mod_security enabled so, before redirecting to the login page, we need to 
       remove all the character which are not matching with the following regular expression: \\%((?!$|\\W)|[0-9a-fA-F]{2}|u[0-9a-fA-F]{4})
       As the bup parameter gets double encoded the previous regular expression is not accomplished and this ended up sending the user to 
       a 403 page. This is the use case where someone copy the url on the entry page and the URL includes the bup parameter.
       The workaround in this case is to detect that you are sending the user to the entry page after logging and remove any double encoding string.
    */
    let url = window.location.href.replace('https:', '').replace('http:', '');
    if (url.includes('/entry/') && url.includes('bup=')) {
        url = url.split('?')[0];
    }
    const bvurl = encodeURIComponent(url)
    window.location.href = `${process.env.REACT_APP_LOGIN_URL}?bvurl=${bvurl}`;
}

export function redirectToLogout () {
    window.location.href = process.env.REACT_APP_LOGOUT_URL;
}